<template>
  <span
    v-if="mobile"
    class="flex justify-center py-4 tttest"
    :class="sectionToShow !== '' ? 'cursor-pointer' : ''"
    @click="showSection('')"
  >
    <span v-if="sectionToShow !== ''" class="mr-6">
      <img
        :src="require('@/assets/images/ic-back.svg')"
        alt="prev"
        class="close-icon mr-2"
      />
    </span>
    <img
      :src="getImageUrl(userDetail)"
      class="lazyload user-profile"
      alt="userProfile"
      @error="$event.target.src = require('@/assets/images/placeholder-user.svg')"
    />
    <h3 class="ml-4">{{ userDetail.first_name }} {{ userDetail.last_name }}</h3>
  </span>
  <w-navigation
    v-if="sectionToShow === ''"
    :params="{
      name: 'ProfilePage',
      params: { region: getRegion, slug: userDetail.slug },
    }"
    :full="false"
  >
    <template #link>
      <span>{{ $t("general.header.dropdown.user.myProfile") }}</span>
    </template>
  </w-navigation>
  <span v-if="mobile && sectionToShow === ''" @click="showSection('notifications')">
    {{ $t("general.header.notifications") }}
  </span>
  <w-navigation
    v-if="sectionToShow === ''"
    :params="{ name: 'MyProfilePage', params: { region: getRegion } }"
    :full="false"
  >
    <template #link>
      <span>{{ $t("general.header.dropdown.user.myData") }}</span>
    </template>
  </w-navigation>
  <w-navigation
    v-if="sectionToShow === ''"
    :params="{ name: 'MyTicketsPage', params: { region: getRegion } }"
    :full="false"
  >
    <template #link>
      <span>{{ $t("general.header.dropdown.user.myTickets") }}</span>
    </template>
  </w-navigation>
  <w-navigation
    v-if="sectionToShow === '' && mobile && getRegion !== 'mx'"
    :params="{
      name: 'MyWeswapPage',
      params: { region: getRegion },
    }"
    :full="false"
  >
    <template #link>
      <span>{{ $t("general.header.dropdown.user.weswap") }}</span>
    </template>
  </w-navigation>
  <w-navigation
    v-if="sectionToShow === ''"
    :params="{
      name: 'ProfileSettingsPage',
      params: { region: getRegion },
    }"
    :full="false"
  >
    <template #link>
      <span>{{ $t("general.header.dropdown.user.settings") }}</span>
    </template>
  </w-navigation>
  <w-navigation
    v-if="sectionToShow === ''"
    :params="{ name: 'HelpPage', params: { region: getRegion } }"
    :full="false"
  >
    <template #link>
      <span>{{ $t("general.header.dropdown.user.help") }}</span>
    </template>
  </w-navigation>
  <a
    v-if="(userDetail.is_staff || userDetail.promoter_status > 0) && sectionToShow === ''"
    :href="backofficeUrl"
  >
    <span>{{ $t("general.header.dropdown.user.backoffice") }}</span>
  </a>
  <span v-if="sectionToShow === ''" @click="closeSession">{{
    $t("general.header.dropdown.user.closeSession")
  }}</span>
  <div v-if="sectionToShow === 'notifications'" class="notifications-dropdown">
    <header-notification />
  </div>
</template>

<script setup>
import { useUser } from "@/composables/useUser";
import WNavigation from "@/components/general/ui/WNavigation";
import HeaderNotification from "@/components/general/ui/navbar/HeaderNotification";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

const { userDetail, closeSession } = useUser();
const route = useRoute();
const sectionToShow = ref("");

const backofficeUrl = process.env.VUE_APP_BACKOFFICE;

defineProps({
  mobile: {
    type: Boolean,
    default: false,
  },
});

const getRegion = computed(() => {
  return route.params.region || userDetail.value.region || "es";
});

const showSection = (section) => {
  sectionToShow.value = section;
};

const getImageUrl = (element) => {
  if (element?.thumbnails?.s_sq) {
    return element.thumbnails.s_sq;
  } else if (element?.image_url) {
    return element.image_url;
  } else {
    return require("@/assets/images/placeholder-user.svg");
  }
};
</script>

<style lang="scss" scoped>
.notifications-dropdown {
  background-color: $backgroundGrey;
  max-height: 100%;
  width: 80vw;
  overflow-y: auto;
  overflow-x: hidden;
}
.user-profile {
  border-radius: 100%;
  height: 33px;
  width: 33px;
}
</style>
